// import React, { useState, useEffect } from "react";
// import { Button } from "./ui/button";
// import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
// import { Badge } from "./ui/badge";
// import { ArrowLeft, Calendar, User, Eye, Share2, Heart, Bookmark, Facebook, Twitter, MessageCircle } from "lucide-react";
// import axios from "axios";
// import { useParams } from "react-router-dom";

// const ArticleView = ({ articleId, onBack }) => {
//   const [article, setArticle] = useState(null);
//   const [relatedArticles, setRelatedArticles] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [liked, setLiked] = useState(false);
//   const [bookmarked, setBookmarked] = useState(false);

//   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
//   const API = `${BACKEND_URL}/api`;

//   useEffect(() => {
//     if (articleId) {
//       fetchArticle();
//     }
//   }, [articleId]);

//   const fetchArticle = async () => {
//     try {
//       // Get the article content
//       const response = await axios.post(`${API}/search/content`, {
//         query: ""
//       });

//       const allContent = [...(response.data.related_videos || []), ...(response.data.related_content || [])];
//       const currentArticle = allContent.find(item => item.id === articleId);

//       if (currentArticle) {
//         setArticle(currentArticle);

//         // Get related articles based on tags
//         const related = allContent.filter(item => 
//           item.id !== articleId && 
//           item.tags.some(tag => currentArticle.tags.includes(tag))
//         ).slice(0, 3);

//         setRelatedArticles(related);
//       }

//     } catch (error) {
//       console.error("Error fetching article:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('id-ID', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const handleShare = (platform) => {
//     const url = window.location.href;
//     const title = article?.title || '';

//     switch (platform) {
//       case 'facebook':
//         window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
//         break;
//       case 'twitter':
//         window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`, '_blank');
//         break;
//       case 'whatsapp':
//         window.open(`https://wa.me/?text=${encodeURIComponent(title + ' ' + url)}`, '_blank');
//         break;
//       default:
//         navigator.clipboard.writeText(url);
//         alert('Link berhasil disalin!');
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
//           <p className="text-gray-600 dark:text-gray-300">Memuat artikel...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!article) {
//     return (
//       <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
//         <div className="text-center">
//           <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4">Artikel Tidak Ditemukan</h2>
//           <Button onClick={onBack}>
//             <ArrowLeft className="w-4 h-4 mr-2" />
//             Kembali
//           </Button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
//       {/* Header */}
//       <header className="bg-white dark:bg-gray-800 shadow-sm">
//         <div className="container mx-auto px-4 py-4">
//           <Button variant="ghost" onClick={onBack} className="mb-4">
//             <ArrowLeft className="w-4 h-4 mr-2" />
//             Kembali ke Beranda
//           </Button>
//         </div>
//       </header>

//       {/* Article Content */}
//       <main className="container mx-auto px-4 py-8">
//         <div className="max-w-4xl mx-auto">
//           <div className="grid lg:grid-cols-3 gap-8">
//             {/* Main Article */}
//             <div className="lg:col-span-2">
//               <article className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden">
//                 {/* Article Header */}
//                 <div className="p-6 border-b border-gray-200 dark:border-gray-700">
//                   <div className="flex flex-wrap gap-2 mb-4">
//                     {article.tags.map((tag) => (
//                       <Badge key={tag} variant="secondary">
//                         {tag}
//                       </Badge>
//                     ))}
//                   </div>

//                   <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4 leading-tight">
//                     {article.title}
//                   </h1>

//                   <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400">
//                     <div className="flex items-center space-x-4">
//                       <div className="flex items-center">
//                         <User className="w-4 h-4 mr-1" />
//                         <span>Admin MPStore</span>
//                       </div>
//                       <div className="flex items-center">
//                         <Calendar className="w-4 h-4 mr-1" />
//                         <span>{formatDate(article.created_at)}</span>
//                       </div>
//                       <div className="flex items-center">
//                         <Eye className="w-4 h-4 mr-1" />
//                         <span>{Math.floor(Math.random() * 1000) + 100} views</span>
//                       </div>
//                     </div>

//                     <div className="flex items-center space-x-2">
//                       <Button
//                         variant="ghost"
//                         size="sm"
//                         onClick={() => setLiked(!liked)}
//                         className={liked ? "text-red-500" : ""}
//                       >
//                         <Heart className={`w-4 h-4 ${liked ? 'fill-current' : ''}`} />
//                       </Button>
//                       <Button
//                         variant="ghost"
//                         size="sm"
//                         onClick={() => setBookmarked(!bookmarked)}
//                         className={bookmarked ? "text-blue-500" : ""}
//                       >
//                         <Bookmark className={`w-4 h-4 ${bookmarked ? 'fill-current' : ''}`} />
//                       </Button>
//                       <Button variant="ghost" size="sm" onClick={() => handleShare('copy')}>
//                         <Share2 className="w-4 h-4" />
//                       </Button>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Article Body */}
//                 <div className="p-6">
//                   {article.content_data.url && article.content_type === 'image' && (
//                     <div className="mb-6">
//                       <img
//                         src={article.content_data.url}
//                         alt={article.title}
//                         className="w-full rounded-lg"
//                       />
//                     </div>
//                   )}

//                   {article.content_data.embed_url && article.content_type === 'video_youtube' && (
//                     <div className="mb-6 aspect-video">
//                       <iframe
//                         src={article.content_data.embed_url}
//                         title={article.title}
//                         className="w-full h-full rounded-lg"
//                         allowFullScreen
//                       />
//                     </div>
//                   )}

//                   <div className="prose prose-lg max-w-none dark:prose-invert">
//                     {article.description && (
//                       <p className="text-xl text-gray-600 dark:text-gray-300 mb-6 font-medium leading-relaxed">
//                         {article.description}
//                       </p>
//                     )}

//                     {article.content_data.text ? (
//                       <div className="whitespace-pre-wrap">
//                         {article.content_data.text}
//                       </div>
//                     ) : (
//                       <div>
//                         <p>Ini adalah tutorial lengkap tentang {article.title.toLowerCase()}.</p>
//                         <p>MPStore menyediakan berbagai fitur untuk membantu bisnis UMKM berkembang. Dengan mengikuti tutorial ini, Anda akan dapat:</p>
//                         <ul>
//                           <li>Memahami cara menggunakan fitur dengan optimal</li>
//                           <li>Mengintegrasikan dengan sistem bisnis Anda</li>
//                           <li>Meningkatkan efisiensi operasional</li>
//                         </ul>
//                         <p>Untuk informasi lebih lanjut, silakan hubungi customer service kami melalui WhatsApp atau kunjungi website resmi MPStore.</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Social Share */}
//                 <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Bagikan artikel ini:</span>
//                     <div className="flex space-x-2">
//                       <Button variant="outline" size="sm" onClick={() => handleShare('facebook')}>
//                         <Facebook className="w-4 h-4" />
//                       </Button>
//                       <Button variant="outline" size="sm" onClick={() => handleShare('twitter')}>
//                         <Twitter className="w-4 h-4" />
//                       </Button>
//                       <Button variant="outline" size="sm" onClick={() => handleShare('whatsapp')}>
//                         <MessageCircle className="w-4 h-4" />
//                       </Button>
//                     </div>
//                   </div>
//                 </div>
//               </article>
//             </div>

//             {/* Sidebar */}
//             <div className="lg:col-span-1">
//               <div className="sticky top-24 space-y-6">
//                 {/* Related Articles */}
//                 {relatedArticles.length > 0 && (
//                   <Card>
//                     <CardHeader>
//                       <CardTitle className="text-lg">Artikel Terkait</CardTitle>
//                     </CardHeader>
//                     <CardContent className="space-y-4">
//                       {relatedArticles.map((related) => (
//                         <div key={related.id} className="group cursor-pointer" onClick={() => window.location.href = `/article/${related.id}`}>
//                           <h4 className="font-medium text-sm line-clamp-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors mb-1">
//                             {related.title}
//                           </h4>
//                           <p className="text-xs text-gray-500 dark:text-gray-400">
//                             {formatDate(related.created_at)}
//                           </p>
//                         </div>
//                       ))}
//                     </CardContent>
//                   </Card>
//                 )}

//                 {/* MPStore Resources */}
//                 <Card>
//                   <CardHeader>
//                     <CardTitle className="text-lg">Butuh Bantuan?</CardTitle>
//                   </CardHeader>
//                   <CardContent className="space-y-3">
//                     <Button variant="outline" className="w-full justify-start" onClick={() => window.open('https://api.whatsapp.com/send/?phone=6285812626667', '_blank')}>
//                       <MessageCircle className="w-4 h-4 mr-2" />
//                       Chat Customer Service
//                     </Button>
//                     <Button variant="outline" className="w-full justify-start" onClick={() => window.open('https://mpstore.co.id/news/', '_blank')}>
//                       <Eye className="w-4 h-4 mr-2" />
//                       Lihat Tutorial Lainnya
//                     </Button>
//                   </CardContent>
//                 </Card>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default ArticleView;

import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import { ArrowLeft, Calendar, User, Eye, Share2, Heart, Bookmark, Facebook, Twitter, MessageCircle } from "lucide-react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { formatText } from "../lib/utils"; // Import fungsi formatText

const ArticleView = ({ articleId, onBack }) => {
  const [article, setArticle] = useState(null);
  const [relatedArticles, setRelatedArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [liked, setLiked] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API = `${BACKEND_URL}/api`;

  useEffect(() => {
    if (articleId) {
      fetchArticle();
    }
  }, [articleId]);

  const fetchArticle = async () => {
    try {
      // Get the article content
      const response = await axios.post(`${API}/search/content`, {
        query: ""
      });

      const allContent = [...(response.data.related_videos || []), ...(response.data.related_content || [])];
      const currentArticle = allContent.find(item => item.id === articleId);

      if (currentArticle) {
        setArticle(currentArticle);

        // Get related articles based on tags
        const related = allContent.filter(item =>
          item.id !== articleId &&
          item.tags.some(tag => currentArticle.tags.includes(tag))
        ).slice(0, 3);

        setRelatedArticles(related);
      }

    } catch (error) {
      console.error("Error fetching article:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('id-ID', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const handleShare = (platform) => {
    const url = window.location.href;
    const title = article?.title || '';

    switch (platform) {
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(title + ' ' + url)}`, '_blank');
        break;
      default:
        navigator.clipboard.writeText(url);
        alert('Link berhasil disalin!');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-300">Memuat artikel...</p>
        </div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4">Artikel Tidak Ditemukan</h2>
          <Button onClick={onBack}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            Kembali
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <Button variant="ghost" onClick={onBack} className="mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Kembali ke Beranda
          </Button>
        </div>
      </header>

      {/* Article Content */}
      <main className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Main Article */}
            <div className="lg:col-span-2">
              <article className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden">
                {/* Article Header */}
                <div className="p-6 border-b border-gray-200 dark:border-gray-700">
                  <div className="flex flex-wrap gap-2 mb-4">
                    {article.tags.map((tag) => (
                      <Badge key={tag} variant="secondary">
                        {tag}
                      </Badge>
                    ))}
                  </div>

                  <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4 leading-tight">
                    {article.title}
                  </h1>

                  <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400">
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center">
                        <User className="w-4 h-4 mr-1" />
                        <span>Admin MPStore</span>
                      </div>
                      <div className="flex items-center">
                        <Calendar className="w-4 h-4 mr-1" />
                        <span>{formatDate(article.created_at)}</span>
                      </div>
                      <div className="flex items-center">
                        <Eye className="w-4 h-4 mr-1" />
                        <span>{Math.floor(Math.random() * 1000) + 100} views</span>
                      </div>
                    </div>

                    <div className="flex items-center space-x-2">
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => setLiked(!liked)}
                        className={liked ? "text-red-500" : ""}
                      >
                        <Heart className={`w-4 h-4 ${liked ? 'fill-current' : ''}`} />
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => setBookmarked(!bookmarked)}
                        className={bookmarked ? "text-blue-500" : ""}
                      >
                        <Bookmark className={`w-4 h-4 ${bookmarked ? 'fill-current' : ''}`} />
                      </Button>
                      <Button variant="ghost" size="sm" onClick={() => handleShare('copy')}>
                        <Share2 className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                </div>

                {/* Article Body */}
                <div className="p-6">
                  {article.content_data.url && article.content_type === 'image' && (
                    <div className="mb-6">
                      <img
                        src={article.content_data.url}
                        alt={article.title}
                        className="w-full rounded-lg"
                      />
                    </div>
                  )}

                  {article.content_data.embed_url && article.content_type === 'video_youtube' && (
                    <div className="mb-6 aspect-video">
                      <iframe
                        src={article.content_data.embed_url}
                        title={article.title}
                        className="w-full h-full rounded-lg"
                        allowFullScreen
                      />
                    </div>
                  )}

                  <div className="prose prose-lg max-w-none dark:prose-invert">
                    {article.description && (
                      <p className="text-xl text-gray-600 dark:text-gray-300 mb-6 font-medium leading-relaxed whitespace-pre-wrap">
                        {formatText(article.description)}
                      </p>
                    )}

                    {article.content_data.text ? (
                      <div className="whitespace-pre-wrap">
                        {formatText(article.content_data.text)}
                      </div>
                    ) : (
                      <div>
                        <p>Ini adalah tutorial lengkap tentang {article.title.toLowerCase()}.</p>
                        <p>MPStore menyediakan berbagai fitur untuk membantu bisnis UMKM berkembang.</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Social Share */}
                <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Bagikan artikel ini:</span>
                    <div className="flex space-x-2">
                      <Button variant="outline" size="sm" onClick={() => handleShare('facebook')}>
                        <Facebook className="w-4 h-4" />
                      </Button>
                      <Button variant="outline" size="sm" onClick={() => handleShare('twitter')}>
                        <Twitter className="w-4 h-4" />
                      </Button>
                      <Button variant="outline" size="sm" onClick={() => handleShare('whatsapp')}>
                        <MessageCircle className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                </div>
              </article>
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-24 space-y-6">
                {/* Related Articles */}
                {relatedArticles.length > 0 && (
                  <Card>
                    <CardHeader>
                      <CardTitle className="text-lg">Artikel Terkait</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      {relatedArticles.map((related) => (
                        <div key={related.id} className="group cursor-pointer" onClick={() => window.location.href = `/article/${related.id}`}>
                          <h4 className="font-medium text-sm line-clamp-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors mb-1">
                            {related.title}
                          </h4>
                          <p className="text-xs text-gray-500 dark:text-gray-400">
                            {formatDate(related.created_at)}
                          </p>
                        </div>
                      ))}
                    </CardContent>
                  </Card>
                )}

                {/* MPStore Resources */}
                <Card>
                  <CardHeader>
                    <CardTitle className="text-lg">Butuh Bantuan?</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-3">
                    <Button variant="outline" className="w-full justify-start" onClick={() => window.open('https://api.whatsapp.com/send/?phone=6285812626667', '_blank')}>
                      <MessageCircle className="w-4 h-4 mr-2" />
                      Chat Customer Service
                    </Button>
                    <Button variant="outline" className="w-full justify-start" onClick={() => window.open('https://mpstore.co.id/news/', '_blank')}>
                      <Eye className="w-4 h-4 mr-2" />
                      Lihat Tutorial Lainnya
                    </Button>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ArticleView;